import './FieldStats.scoped.scss'
import { Fragment } from 'react'

export default function FieldStats() {
  const { stats } = useSel((s) => s.dashboard)

  return (
    <div className='box margin-top double no-side-padding' id='usage-stats'>
        <h2 className='field-stat-header'>Dashboard Usage</h2>
        <div className="field-stat-container">
        {stats?.fieldStats?.map((fieldStat, index) => (
            <FieldStat key={index} fieldStat={fieldStat} audienceCount={stats?.audienceCount} />
        ))}
        </div>
    </div>
  )
}

function FieldStat({ fieldStat, audienceCount = null }) {

    const configMap = {
        'goal': {
            propertyKey: 'completedCount',
            formatter: (value) => `${value} / ${audienceCount} completed`,
        },
        'search': {
            propertyKey: 'targetCount',
            formatter: (value) => `${value} / ${audienceCount} in search`,
        },
        'question': {
            propertyKey: 'responsesCount',
            formatter: (value) => `${value} / ${audienceCount} responded`,
        }
    }

    const config = configMap[fieldStat.type]
    if (!config) {
        return null
    }
    const value = fieldStat[config.propertyKey]

    return (<Fragment>
        <div className="field-stat-title">
            {fieldStat.name}
        </div>
        <div className="field-stat-value">
            <p>{config.formatter(value || 0)}</p>
        </div>
    </Fragment>)
}
